<form *ngIf="specialDeviceFG" [formGroup]="specialDeviceFG" class="component-container special-consumer-container">
  <div class="ui-g">
    <div class="ui-g-12 form-rows top-border">
      <div class="ui-g-4 field-rows">
        <label class="ui-g-6 field-label text-right-align required" for="device">
          {{ 'technician-data.form-fields.device' | translate }}
        </label>
        <p-dropdown
          (onChange)="selectSpecialDevice($event)"
          [options]="specialDevices"
          formControlName="device"
          [readonly]="isReadOnly"
          id="device"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + specialDeviceKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'lookup.' + specialDeviceKey + '.options.' + option['value'] + '.name' | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="ui-g-7 field-rows" *ngIf="specialDeviceType === 'other'">
        <label for="power-connection-other-type" class="ui-g-2"></label>
        <input
          id="power-connection-other-type"
          class="ui-input pInputText"
          formControlName="otherType"
          pInputText
          type="text"
          [readonly]="isReadOnly" />
      </div>

      <div class="ui-g-7" *ngIf="specialDeviceType === 'wallbox' || specialDeviceType === 'charger'">
        <div class="ui-g-6">
          <p-checkbox
            binary="true"
            [readonly]="isReadOnly"
            formControlName="consumptionDeviceCheckbox"
            id="base-data-consumption-device-check"
            label="{{ 'facilities-data.form-fields.consumption-device-checkbox' | translate }}"></p-checkbox>
        </div>

        <div class="ui-g-6">
          <p-checkbox
            binary="true"
            [readonly]="isReadOnly"
            formControlName="publicDeviceCheckbox"
            id="base-data-public-device-check"
            label="{{ 'facilities-data.form-fields.public-device-checkbox' | translate }}"></p-checkbox>
        </div>
      </div>

      <div *ngIf="specialDeviceType !== 'wallbox' && specialDeviceType !== 'charger' && specialDeviceType !== 'other'" class="ui-g-7"></div>

      <div (click)="removeElement()" *ngIf="!isReadOnly" class="pi pi-trash pointer-cursor ui-g-1 text-right-align"></div>
    </div>

    <div class="ui-g-12 form-rows">
      <div class="ui-g-4 field-rows">
        <label class="ui-g-5 field-label text-right-align required" for="power-connection-count">
          {{ 'technician-data.form-fields.count' | translate }}
        </label>
        <input
          [appNumber]="true"
          class="ui-input pInputText small-width"
          formControlName="count"
          id="power-connection-count"
          maxlength="5"
          pInputText
          size="30"
          [readonly]="isReadOnly" />
      </div>

      <div class="ui-g-4 field-rows">
        <label class="ui-g-4 field-label text-right-align required" for="power-connection-power">
          {{ 'technician-data.form-fields.power' | translate }}
        </label>
        <input
          [appNumber]="true"
          class="ui-input pInputText small-width"
          formControlName="power"
          id="power-connection-power"
          maxlength="5"
          pInputText
          size="30"
          [readonly]="isReadOnly" />
        <span class="field-unit-label">{{ unitLabels.power }}</span>
      </div>

      <div *ngIf="currentInstallationFlow !== installationFlowType.TemporaryConnection" class="ui-g-4 field-rows">
        <label class="ui-g-5 field-label text-right-align" for="power-connection-description">
          {{ 'technician-data.form-fields.description' | translate }}
        </label>
        <input
          class="ui-input pInputText"
          formControlName="description"
          id="power-connection-description"
          pInputText
          size="30"
          type="text"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div *ngIf="currentInstallationFlow !== installationFlowType.TemporaryConnection" class="ui-g-12">
      <div class="ui-g-12 form-rows">
        <div class="ui-g-4 margin-align">
          <label class="margin-right-align required"></label>
          <p-radioButton
            formControlName="is_public_facility"
            name="public-facility"
            [value]="false"
            [label]="'technician-data.form-fields.controllable-facility' | translate"></p-radioButton>
        </div>
        <div class="ui-g-8 margin-align">
          <p-radioButton
            formControlName="is_public_facility"
            name="public-facility"
            [value]="true"
            [label]="'technician-data.form-fields.public-facility' | translate"></p-radioButton>
        </div>
      </div>
      <div *ngIf="specialDeviceFG.controls.module_type" class="ui-g-12 form-rows">
        <div class="ui-g-4 margin-align">
          <label class="margin-right-align required"></label>
          <p-radioButton
            name="module-type"
            value="module1"
            label="{{ 'technician-data.form-fields.module1' | translate }}"
            formControlName="module_type"></p-radioButton>
        </div>
        <div class="ui-g-4 margin-align">
          <p-radioButton
            name="module-type"
            value="module2"
            label="{{ 'technician-data.form-fields.module2' | translate }}"
            formControlName="module_type"></p-radioButton>
        </div>
        <div class="ui-g-4 margin-align">
          <p-radioButton
            name="module-type"
            value="module3"
            label="{{ 'technician-data.form-fields.module3' | translate }}"
            formControlName="module_type"></p-radioButton>
        </div>
      </div>
    </div>
  </div>
</form>
